module.exports = __webpack_public_path__ + "static/media/double.ac96eec1.svg";